import { memo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import Button from 'beam/dist/Button'
import { makeStyles } from 'beam/dist/styles'
import { ANSWER_TYPE } from './evaluationForm.constants'
import { difference } from '../../../Common/Utils'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  answerPoints: {
    marginLeft: theme.spacing(0.5),
    fontWeight: theme.typography.fontWeightLight,
  },
  buttonSizeSmall: {
    minWidth: theme.spacing(5),
  },
  active: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      background: theme.palette.primary.main,
      color: theme.palette.common.white,
      cursor: 'default',
    },
  },
  loadingProgress: {
    color: theme.palette.secondary.main,
  },
}))

const propTypes = {
  answer: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isPercentageScoreType: PropTypes.bool.isRequired,
  sectionId: PropTypes.number.isRequired,
  questionId: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

const defaultProps = {
  disabled: false,
}

const EvaluationAnswer = ({
  answer,
  isSelected,
  isPercentageScoreType,
  sectionId,
  questionId,
  onClick,
  disabled,
}) => {

  const classes = useStyles()
  const { t } = useTranslation()

  const handleAnswerClick = () => {
    if (isSelected) {
      return
    }

    onClick({
      sectionId,
      questionId,
      selectedOption: answer.id,
    })
  }

  const label = (
    <span>
      {answer.label}
      {answer.type !== ANSWER_TYPE.NOT_APPLICABLE && (
        <span className={classes.answerPoints}>{`(${answer.points}${isPercentageScoreType ? '%' : ''})`}</span>
      )}
    </span>
  )

  return (
    <Button
      className={classes.root}
      classes={{
        outlinedPrimary: isSelected && !disabled ? classes.active : null,
      }}
      onClick={handleAnswerClick}
      variant="outlined"
      color="primary"
      size="small"
      title={
        answer.type === ANSWER_TYPE.NOT_APPLICABLE
          ? t('ignore')
          : t('worthX', { value: `${answer.points}${isPercentageScoreType ? '%' : ''}` })
      }
      aria-label={answer.label}
      disabled={disabled}
      disableRipple
    >
      {label}
    </Button>
  )
}

EvaluationAnswer.propTypes = propTypes

EvaluationAnswer.defaultProps = defaultProps

export default memo(EvaluationAnswer, (prevProps, nextProps) => {
  const diff = difference(nextProps, prevProps)
  return isEmpty(diff)
})
